module.exports = __webpack_public_path__ + "static/CloudBattery-3-dark-0469ea77e44f3938db9257d130cf8399.svg";